import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  trackRequestDetails: {},
  requestDetails: {},
  logisticRequestDetails: {},
  pendingDocs: {},
}

const trackSlice = createSlice({
  name: 'trackSlice',
  initialState,
  reducers: {
    setTrackRequestDetails: (state, action) => {
      state.trackRequestDetails = action.payload
    },
    setRequestDetails: (state, action) => {
      state.requestDetails = action.payload
    },
    setLogisticRequestDetails: (state, action) => {
      state.logisticRequestDetails = action.payload
    },
    setLogisticDocs: (state, action) => {
      state.trackRequestDetails.logisticsEmailDetails = action.payload
    },
    setBerOptionList: (state, action) => {
      state.trackRequestDetails.berOptionList = action.payload
    },
    setPendingDocs: (state, action) => {
      state.pendingDocs = action.payload.map((document) => {
        return {
          ...document,
          isUploaded: !(document.isPendingDocument === 1), // if pending then uploaded as false
        }
      })
    },
  },
})

export default trackSlice.reducer

export const { setTrackRequestDetails, setRequestDetails, setLogisticRequestDetails, setLogisticDocs, setBerOptionList, setPendingDocs } =
  trackSlice.actions
